module.exports = __webpack_public_path__ + "images/pro/img-cipher-mobile@2x-1f99803aca65e1fec01373a7158bb5f4.png";